import { render, staticRenderFns } from "./NuHomeCloneProductCarousel.vue?vue&type=template&id=57d0726f&scoped=true&"
import script from "./NuHomeCloneProductCarousel.vue?vue&type=script&lang=js&"
export * from "./NuHomeCloneProductCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NuHomeCloneProductCarousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NuHomeCloneProductCarousel.vue?vue&type=style&index=1&id=57d0726f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d0726f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d0726f')) {
      api.createRecord('57d0726f', component.options)
    } else {
      api.reload('57d0726f', component.options)
    }
    module.hot.accept("./NuHomeCloneProductCarousel.vue?vue&type=template&id=57d0726f&scoped=true&", function () {
      api.rerender('57d0726f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NuHomeCloneProductCarousel/NuHomeCloneProductCarousel.vue"
export default component.exports